import NewDashboard from "../ArViews/NewDashboard";
import { connect } from "react-redux";
import { spendBudget, recivBudget, getFs, modifyFs, specRecivBud} from "../Actions/Finance_actions";
import { getWeeklyDb, getMonthDb, getDailyDb } from '../Actions/finTrans_actions';

const mapStateToProps = ({Fs, Indicate, Daily, Week, Month}) => { 
        
 return ({
    loading: Indicate,
    budg: Fs.map(list => list.budg),
    allFs: Fs.length >= 1 ? Fs : '',
    stFs: Fs,
    daily: Daily,
    bal: Fs.map(s => s.money),
    myWeek: Week,
    myMonth: Month,
})
}
const mapDispatchToProps = dispatch => {
    
    return {
        
    moneySpent: ({budg, amt, purpose}) => dispatch(spendBudget({budg: budg, amt: amt, purpose: purpose})),

    moneyReciv: ({purpose, amt}) => dispatch(recivBudget({purpose: purpose, amt: amt })),

    getDataFromMongo: () =>  dispatch( getFs() ),
    
    sendNewDataToMongo: (arr) =>  modifyFs(arr),

    moneyRecivSpec: ({purpose, budg, amt}) => dispatch(specRecivBud({purpose:purpose , budg:budg, amt:amt})),

    getWeekly: () => dispatch(getWeeklyDb()),

    getMonthly: () => dispatch(getMonthDb()),

    getDaily: () => dispatch(getDailyDb())

     }
}
 
  
export default connect(mapStateToProps, mapDispatchToProps)(NewDashboard);